import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../actions'
import FeestatisticsFilter from './feestatisticsFilter'

import { reduxForm, Field } from 'redux-form'
import { renderTextField } from '../auth/form_helpers'
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton'

import {List, ListItem} from 'material-ui/List';
import ActionFace from 'material-ui/svg-icons/action/face';
import { darkBlack } from 'material-ui/styles/colors';
import AppBar from 'material-ui/AppBar';
// import Waypoint from 'react-waypoint';
import {Card, CardText, CardTitle} from 'material-ui/Card';
import Paper from 'material-ui/Paper';

var FileSaver = require('file-saver');

var params = '?';

const styles = {
  block: {
    maxWidth: 250,
  },
  checkbox: {
    marginBottom: 16,
  },
  thin: {
    paddingTop: 0,
    paddingBottom: 0,
    marginBottom: 0,
  },
  halfthin: {
    paddingBottom: 0,
    marginBottom: 0,
  },
  tobottom: {
    bottom: 0,
    top: "auto"
  }
};

class Feestatistics extends Component {

  componentWillUnmount() {
    if (this.props.errorMessage) {
      this.props.authError(null)
    }
  }

  componentWillMount() {
    // this.props.getEnums('/stats/group-amounts', '?by=year', 'GroupsByYear'); // Filter : type
    this.props.getEnums('/stats/fee-overview', '?year='+(new Date()).getFullYear(), 'FeeOverview'); //  Filter : year
    this.props.getEnums('/stats/debitors', '/one-year?offset=0&limit=50', 'DebitorsOneYear'); //  Filter : year
    this.props.getEnums('/stats/debitors', '/two-year?offset=0&limit=50', 'DebitorsTwoYear'); //  Filter : year
  }

  handleFilter({year}) {
    params = '?';
    if (typeof year !== 'undefined' && year !== 'all') {
      params = params + 'year='+year
    }
    if (year === 'all') {
      this.props.getEnums('/stats/fee-overview', '', 'FeeOverview'); //  Filter : year
      this.props.getEnums('/stats/debitors', '/one-year', 'DebitorsOneYear'); //  Filter : year
      this.props.getEnums('/stats/debitors', '/two-year', 'DebitorsTwoYear'); //  Filter : year
    } else {
      this.props.getEnums('/stats/fee-overview', params, 'FeeOverview'); //  Filter : year
      this.props.getEnums('/stats/debitors', '/one-year'+params, 'DebitorsOneYear'); //  Filter : year
      this.props.getEnums('/stats/debitors', '/two-year'+params, 'DebitorsTwoYear'); //  Filter : year
    }
  }

  renderNumber(number) {
    Number.prototype.format = function(n, x, s, c) {
        var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
            num = this.toFixed(Math.max(0, ~~n));

        return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
    };
    return number.format(0, 3, ' ', '.')
  }
  
  csvExport = () => {
    // let d = new Date();
    // let t = d.getTime();
    // let fullparam = '?'
    /*
    if (typeof this.state.filterparams !== 'undefined' && this.state.filterparams !== '') {
      if (this.state.filterparams.indexOf('?') > -1) {
        fullparam = this.state.filterparams+'&t='+t
      } else {
        fullparam = '?'+this.state.filterparams+'&t='+t
      }
    } else {
      fullparam = fullparam+'t='+t
    }
    */
    var request = new XMLHttpRequest();
    // request.open('GET', 'https://admin.magyarpszichodrama.hu/api/v1.0/stats/debitors/by-years.csv?years='+this.props.feestatistics.values.yearFrom);
    request.open('GET', '//admin.magyarpszichodrama.hu/api/v1.0/stats/debitors/stat.csv');
    request.responseType = 'blob';
    request.setRequestHeader('X-Auth-Token', localStorage.getItem('token'));
    var blob;
    request.onload = function() {
      blob = request.response;
      FileSaver.saveAs(blob, "debitors.csv");
    };
    request.send();
  }

  render() {
    if(/*typeof this.props.groupsbyyear !== 'undefined' && */typeof this.props.feeoverview !== 'undefined' && typeof this.props.debitorsoneyear !== 'undefined' && typeof this.props.debitorstwoyear !== 'undefined') {
      return (
        <div style={{paddingBottom: 351}}>
          <AppBar
            title="Befizetés statisztikák"
          />
          <FeestatisticsFilter
            onSubmit={this.handleFilter.bind(this)}
            // groupsbyyear={this.props.groupsbyyear}
            errorMessage={this.props.errorMessage} />
          <Card key={0}>
            <CardText expandable={false}>
              <div className='container'>
                <div className='row'>
                  <div className='col-md-6 col-xs-12 text-center mb-1 md-mb-1'>
                    <Paper className='p-y-1' zDepth={1}>
                      <label>Összes befizetés:</label>
                      <br />
                      <h3>
                        {this.renderNumber(this.props.feeoverview.overallSum)} Ft
                      </h3>
                    </Paper>
                  </div>
                  <div className='col-md-6 col-xs-12 text-center mb-1 md-mb-1'>
                    <Paper className='p-y-1' zDepth={1}>
                      <label>Tagdíjfizetési hajlandóság:</label>
                      <br />
                      <h3>
                        {this.props.feeoverview.inclinationPercent} %
                      </h3>
                    </Paper>
                  </div>
                  <div className='col-md-4 col-xs-12 text-center mb-1 md-mb-1'>
                    <Paper className='p-y-1' zDepth={1}>
                      <label>Összes befizetés tagdíjból:</label>
                      <br />
                      <h3>
                        {this.renderNumber(this.props.feeoverview.membershipFeeSum)} Ft
                      </h3>
                    </Paper>
                  </div>
                  <div className='col-md-4 col-xs-12 text-center mb-1 md-mb-0'>
                    <Paper className='p-y-1' zDepth={1}>
                      <label>Összes befizetés regisztrációs díjból:</label>
                      <br />
                      <h3>
                        {this.renderNumber(this.props.feeoverview.registrationFeeSum)} Ft
                      </h3>
                    </Paper>
                  </div>
                  <div className='col-md-4 col-xs-12 text-center mb-1 md-mb-0'>
                    <Paper className='p-y-1' zDepth={1}>
                      <label>Összes befizetés csoportregisztrációból:</label>
                      <br />
                      <h3>
                        {this.renderNumber(this.props.feeoverview.groupRegistrationFeeSum)} Ft
                      </h3>
                    </Paper>
                  </div>
                </div>
                <div className='row'>
                  <div className='col-xs-12 text-center'>
                    <Paper className='p-y-1' zDepth={1}>
                      <h4>Nemfizetők évenkénti bontásban</h4>
                      { /*   <label>Nemfizető évek, vesszővel elválasztva:</label> */}
                      <form className='flexContainer toleft flexCenter'>
                        { /*
                        <Paper zDepth={0} style={styles.thin}>
                          <Field
                            component={renderTextField}
                            floatingLabelText="évszám,évszám"
                            name="yearFrom"
                            type="text"/>
                        </Paper>
                        */ }
                        <Paper zDepth={0} style={styles.halfthin}>
                          <RaisedButton label="CSV Export" primary={true} labelColor={'#FFFFFF'} onClick={this.csvExport.bind(this)} />
                        </Paper>
                      </form>
                    </Paper>
                  </div>
                  { /*
                  <div className='col-xs-6'>
                    <Card className="" key={0}>
                      <CardTitle title="Idén még nem fizettek tagdíjat" subtitle="" />
                      <CardText expandable={false}>
                        <List>
                          {
                            this.props.debitorsoneyear.map((option, index) => {
                              return <ListItem
                                //onClick={this.handleOpen.bind(this, option.id)}
                                key={index}
                                leftIcon={<ActionFace />}
                                primaryText={
                                  <span>
                                    <a href={"/persons/"+option.id} target="_blank">
                                      <span style={{color: darkBlack}}>{option.name}</span>
                                    </a>
                                  </span>
                                }
                                />
                            })
                          }
                        </List>
                      </CardText>
                    </Card>
                  </div>
                  <div className='col-xs-6'>
                    <Card className="" key={1}>
                      <CardTitle title="Két éve nem fizettek tagdíjat" subtitle="" />
                      <CardText expandable={false}>
                        <List>
                          {
                            this.props.debitorstwoyear.map((option, index) => {
                              return <ListItem
                                //onClick={this.handleOpen.bind(this, option.id)}
                                key={index}
                                leftIcon={<ActionFace />}
                                primaryText={
                                  <span>
                                    <a href={"/persons/"+option.id} target="_blank">
                                      <span style={{color: darkBlack}}>{option.name}</span>
                                    </a>
                                  </span>
                                }
                                />
                            })
                          }
                        </List>
                      </CardText>
                    </Card>
                  </div>
                  <div className='col-xs-12'>
                    <Waypoint onEnter={({ previousPosition, currentPosition, event }) => {
                        if (this.props.debitorsoneyear.length > 49) {
                          this.props.getEnums('/stats/debitors', '/one-year'+params+'?offset='+this.props.debitorsoneyear.length+'&limit=50', 'DebitorsOneYearMore'); //  Filter : year
                          //this.props.getEnums('/stats/top-leaders', '?offset='+this.props.topleaders.length+'&limit=50', 'TopLeadersMore');
                        }
                        if (this.props.debitorstwoyear.length > 49) {
                          this.props.getEnums('/stats/debitors', '/two-year'+params+'?offset='+this.props.debitorstwoyear.length+'&limit=50', 'DebitorsTwoYearMore'); //  Filter : year
                          //this.props.getEnums('/stats/top-leaders', '?offset='+this.props.topleaders.length+'&limit=50', 'TopLeadersMore');
                        }
                      }}
                    />
                  </div>
                  */ }
                </div>
              </div>
            </CardText>
          </Card>
        </div>
      )
    } else {
      return (
        <div>
          <p style={{margin: 16, textAlign: "center"}}><strong>Statisztikákat töltünk...</strong></p>
        </div>

      )

    }
  }
}

function mapStateToProps(state) {
  return {
    feestatistics: state.form.feestatistics,
    // groupsbyyear: state.statistics.groupsbyyear,
    feeoverview: state.statistics.feeoverview,
    debitorsoneyear: state.statistics.debitorsoneyear,
    debitorstwoyear: state.statistics.debitorstwoyear,
    errorMessage: state.auth.error
  }
}

Feestatistics = reduxForm({
  form: 'feestatistics'
})(Feestatistics)
export default connect(mapStateToProps, actions)(Feestatistics)


// WEBPACK FOOTER //
// ./src/components/feestatistics/feestatistics.js